import clsx from 'clsx'
import Clickable from 'components/Common/Clickable'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import eases from 'styles/tools/eases'

const Bubble = styled(Clickable)`
  height: ${rem(8)};
  width: ${rem(8)};
  border-radius: ${props => props.theme.borderRadius.round};
  border: 1px solid ${props => props.theme.palette.neutral.one};
  background-color: ${props => props.theme.palette.neutral.eight};
  transition: all 0.5s ${eases.power1.inOut};

  &.active {
    width: ${rem(16)};
    background-color: ${props => props.theme.palette.neutral.one};
  }
`

interface Props {
  count: number;
  active: number;
  onSelect: (position: number) => void;
}

const Bubbles = (props: Props) => (
  <Group direction="horizontal" gap={4}>
    {Array.from(Array(props.count)).map((_, i) => (
      <Bubble
        key={i}
        className={clsx({ active: props.active === i })}
        onClick={() => props.onSelect(i)}
        disabled={props.active === i}
      />
    ))}
  </Group>
)

export default Bubbles
